define('MM/Components/ContentSearch/PropertyBackLink',[
    "jquery"
],
    function ($) {

        function PropertyBackLink(args) {
            if (args.IsEditing) {
                return;
            }

            var $link = $(".mm-js-back-to-search", args.scope);

            $link.on("click", function (event) {
                event.preventDefault();

                if (args.ReturnUrl) {
                    if (args.UrlSegment === 'undefined') {
                        console.log("%cUrlSegment is not setup correctly for the page", "color: red; font-family: sans-serif; font-size: 1.2em; font-weight: bolder; text-shadow: #000 1px 1px;");
                    }

                    var virtualPath = new URL(args.ReturnUrl).pathname;
                    if (virtualPath.startsWith(args.UrlSegment)) {
                        history.go(-1);
                        return;
                    }

                    window.location.href = args.ReturnUrl;
                }
            });
        }

        return function init(args) {
            return new PropertyBackLink(args);
        };
    });
